// Styling
import { Button, Icon } from "@jkast90/kast-common/ui";
import dialogCss from "../../styles/Dialog.module.css";
import type { ShownReminder } from "./reminderShape";

export default function ReminderPopup({
  reminder,
  onComplete,
  onSnooze,
  onClear,
}: {
  reminder: ShownReminder | null;
  onComplete: () => void;
  /** Called with the minutes to snooze for. */
  onSnooze: (minutes: number) => void;
  onClear: () => void;
}) {
  if (!reminder || !reminder.note) return null;

  return (
    <div className={dialogCss.overlay}>
      <div className={dialogCss.popup}>
        <h3>
          <Icon name="alarm" size={20} /> Reminder
        </h3>
        <h4>{reminder.note.title}</h4>
        <p>{reminder.note.text}</p>

        <div className={dialogCss.actions}>
          <Button size="sm" onClick={() => onSnooze(0.5)}>
            30s
          </Button>
          <Button size="sm" onClick={() => onSnooze(5)}>
            5m
          </Button>
          <Button size="sm" onClick={() => onSnooze(30)}>
            30m
          </Button>
          <Button size="sm" onClick={() => onSnooze(60)}>
            1h
          </Button>
          <Button size="sm" onClick={() => onSnooze(240)}>
            4h
          </Button>
          <Button size="sm" onClick={onComplete}>
            Mark Complete
          </Button>
          <Button size="sm" onClick={onClear}>
            Cancel Reminder
          </Button>
        </div>
      </div>
    </div>
  );
}
